import Spinner from '@/shared/components/Spinner';

export default function PaymentLoadingState() {
  return (
    <div className="flex items-center justify-center py-4">
      <Spinner />
    </div>
  );
}
